import React, {useEffect, useMemo, useState} from 'react';
import TextEditor from "../../../components/Utils/TextEditor/TextEditor";
import styles from "./AboutText.module.css";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import {getTextsAbout} from "../../../store/selectors/textsSelectors";
import {getLanguage} from "../../../store/selectors/appSelector";
import {EnumTextTypes} from "../../../enums/EnumTextTypes";
import AdminEditableTextWrapper
    from "../../../components/Utils/Admins/AdminEditableTextWrapper/AdminEditableTextWrapper";
import {updatePageTextThunk} from "../../../store/actions/TextsActions";
import {getTextByLanguage} from "../../../enums/utils/getTextByLanguage";


const AboutText = () => {
    const dispatch = useAppDispatch()
    const texts = useAppSelector(getTextsAbout)
    const language = useAppSelector(getLanguage)
    const mainText = texts.find(text => text.type === EnumTextTypes.main)

    const configTextEditor = useMemo(() => {
        return {
            language,
            hidePoweredByJodit: true,
            className: styles.textWrapper,
        }
    }, [language])


    const [value, setValue] = useState<string>(mainText ? getTextByLanguage(mainText.text, language) : 'Скоро тут будет текст')


    useEffect(() => {
        mainText && setValue(getTextByLanguage(mainText.text, language))
    }, [language, mainText])


    const [isEditMode, setIsEditMode] = useState<boolean>(false)

    const updateText = () => {

        mainText && dispatch(updatePageTextThunk({
            id: mainText.id,
            text: value,
            language
        }))
        setIsEditMode(false)
    }


    return (
        <>
            {isEditMode &&
                <TextEditor setIsEditMode={setIsEditMode} updateText={updateText} setValue={setValue} value={value}
                            config={configTextEditor}/>}
            {!isEditMode && <AdminEditableTextWrapper setEditMode={setIsEditMode}>
                <div className={styles.textWrapper}
                     dangerouslySetInnerHTML={{__html: value.length ? value : '<p>Скоро тут будет текст</p>'}}>
                </div>
            </AdminEditableTextWrapper>
            }
        </>
    );
};

export default AboutText;